import { useInfiniteQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { globalSearchQueryKeys } from '../constants'

export const useGlobalSearchGetPinsQuery = (
  projectId = null,
  filterId = null,
  searchKey = '',
  options
) => {
  const {
    sort = 'LastModified',
    direction = 'DESC',
    size = 15,
    stateFilter = 'All',
    enabled: optionsEnabled = true,
    ...queryOptions
  } = options ?? {}
  const enabled = !!projectId && !!filterId && optionsEnabled

  const handleQuery = async ({ pageParam }) => {
    const config = {
      method: 'get',
      params: {
        projectId,
        filterId,
        page: pageParam,
        sort,
        direction,
        size,
        stateFilter
      }
    }
    const { data } = await api(`/api/v2/projects/${projectId}/pins`, config)

    return data
  }

  return useInfiniteQuery({
    queryKey: [
      globalSearchQueryKeys.GET_PINS,
      projectId,
      searchKey,
      sort,
      direction,
      size,
      stateFilter
    ],
    queryFn: handleQuery,
    initialPageParam: 0,
    getNextPageParam: (lastPage, _pages, lastPageParam) => {
      if (lastPage.last === true) {
        return undefined
      }
      return lastPageParam + 1
    },
    retry: 0,
    refetchOnWindowFocus: false, // Disable refetch on window focus
    keepPreviousData: true,
    ...queryOptions,
    enabled
  })
}
